import { createSlice, PayloadAction } from "@reduxjs/toolkit"

// Feedback values: 0 = dislike, 1 = like, null = no feedback
export type FeedbackType = 0 | 1 | null

export interface ConversationMessage {
  id?: string
  responder_type: "user" | "assistant" | "system"
  content: string
  content_type?: string
  created_at?: number
  feedback?: FeedbackType
}

interface ConversationState {
  conversationMessages: ConversationMessage[]
  conversationId: string | null
  creatingConversation: boolean
  restartingConversation: boolean
}

const initialState: ConversationState = {
  conversationMessages: [],
  conversationId: null,
  creatingConversation: false,
  restartingConversation: false,
}

const conversationsStore = createSlice({
  name: "swayamConversations",
  initialState,
  reducers: {
    setConversationMessages: (state, action: PayloadAction<ConversationMessage[]>) => {
      state.conversationMessages = action.payload
    },
    appendConversationMessage: (state, action: PayloadAction<ConversationMessage>) => {
      state.conversationMessages.push(action.payload)
    },
    setConversationId: (state, action: PayloadAction<string | null>) => {
      state.conversationId = action.payload
    },
    setCreatingConversation: (state, action: PayloadAction<boolean>) => {
      state.creatingConversation = action.payload
    },
    setRestartingConversation: (state, action: PayloadAction<boolean>) => {
      state.restartingConversation = action.payload
    },
    setMessageFeedback: (state, action: PayloadAction<{ messageId: string; feedback: FeedbackType }>) => {
      const message = state.conversationMessages.find((msg) => msg.id === action.payload.messageId)
      if (message) {
        message.feedback = action.payload.feedback
      }
    },
    resetConversationState: () => initialState,
  },
})

export const {
  setConversationMessages,
  setConversationId,
  setCreatingConversation,
  appendConversationMessage,
  setRestartingConversation,
  setMessageFeedback,
  resetConversationState,
} = conversationsStore.actions

export default conversationsStore.reducer
